import { NEXT_PUBLIC_AFTERPAY_ENV } from "../shared/constants";

export const isProd = (): boolean => {
    return NEXT_PUBLIC_AFTERPAY_ENV === "prod";
};
